export const FETCH_FORM_START = "FETCH_FORM_START_FORM";
export const FETCH_FORM_SUCCESS = "FETCH_FORM_SUCCESS_FORM";
export const FETCH_FORM_FAIL = "FETCH_FORM_FAIL_FORM_FORM";

export const UPDATE_FORM_START = "UPDATE_FORM_START_FORM";
export const UPDATE_FORM_SUCCESS = "UPDATE_FORM_SUCCESS_FORM";
export const UPDATE_FORM_FAIL = "UPDATE_FORM_FAIL_FORM_FORM";

export const RESET_FORM = "RESET_FORM";
